import CounterItem from './counterItem/counterItem';
import { Col, Row } from 'react-bootstrap';

export default function Counter() {
    // Counters Options
    const Counters = [
        {
            id: 0,
            title: 'Total Characters'
        },
        {
            id: 1,
            title: 'Word Count'
        },
        {
            id: 2,
            title: 'Sentence Count'
        }
    ]

    return (
        <div>
            <Row className='g-3 text-dark mt-3'>
                {
                    Counters.map(item => {
                        return (
                            <Col key={item.id} className='col-12 col-lg-4'>
                                <CounterItem {...item} />
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    );
}